import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>产品中心</h2>
          <p>模架制造业软件开发20+经验，具有先进模架制造厂管理经验。</p>
        </div>
        <div className="row flex flex-wrap">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-6 mx-auto">
                  {" "}
                  {/* <i className={d.icon}></i> */}
                  {d.url ? (
                    <a href={d.url} target="_blank" rel="noopener noreferrer">
                      <i
                        className={`${d.icon}  hover:scale-110 transition-transform duration-500`}
                      ></i>
                    </a>
                  ) : (
                    <i className={d.icon}></i>
                  )}
                  <div className="service-desc text-left sm:mx-28 max-sm:mx-10">
                    <h3 className=" text-center">{d.name}</h3>
                    {/* <p>{d.text}</p> */}
                    {d.texts.map((t, j) => (
                      <p key={`${t}-${j}`}>{t}</p>
                    ))}
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
